import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { Input, Bubble } from 'tea-component';
import useSelector from '../../hooks/useSelector';

import type { IBaseProps, IDateType, IDateValue } from '@/pages/intelligence/types/common';
import type { IPickerValue, IDateTypeOption } from '../../types';

interface ISelectorProps extends IBaseProps {
  disabled?: boolean;
  types: IDateTypeOption[];
  defaultValue: IPickerValue;
  onConfirm?: (type: IDateType, value: IDateValue) => void;
  onCancel?: () => void;
  onClose?: () => void;
}

export default function Selector(props: ISelectorProps) {
  const { disabled = false, types, defaultValue, onConfirm, onCancel, onClose } = props;

  const { formatMessage } = useIntl();

  const { type, rangeDate, errorMessage, handleConfirm, handleCancel, handleTypeChange, handleRangeDateChange } =
    useSelector({
      defaultValue,
      onConfirm,
      onCancel,
      onClose,
    });

  const typeName = types?.find((item) => item?.value === type)?.name || '';

  return (
    <div className="range-day-month-selector-dropdown-dbi">
      {types?.length > 1 && (
        <div className="range-day-month-selector-tab-type">
          {types?.map((item) => (
            <span
              key={item.value}
              className={classnames('range-day-month-selector-tab-type-item', {
                'is-disabled': disabled,
                'range-day-month-selector-active': item.value === type,
              })}
              onClick={() => {
                if (disabled) return;
                handleTypeChange(item.value);
              }}
            >
              {formatMessage({ id: item.name })}
            </span>
          ))}
        </div>
      )}
      <div className="range-day-month-selector-range-input">
        {formatMessage({ id: 'dbi_range_month_picker_launch' })}
        <Bubble
          visible={errorMessage[0]?.length > 0}
          overlayClassName="range-day-month-selector-bubble"
          placement="bottom"
          content={errorMessage[0]}
          error
        >
          <Input
            disabled={disabled}
            value={rangeDate[0]}
            onChange={(value) => handleRangeDateChange([value, rangeDate[1]])}
          />
        </Bubble>
        <i>-</i>
        <Bubble
          visible={errorMessage[1]?.length > 0}
          overlayClassName="range-day-month-selector-bubble"
          placement="bottom"
          content={errorMessage[1]}
          error
        >
          <Input
            disabled={disabled}
            value={rangeDate[1]}
            onChange={(value) => handleRangeDateChange([rangeDate[0], value])}
          />
        </Bubble>
        {formatMessage({ id: typeName })}
      </div>
      <div className="range-day-month-selector-footer">
        <span className="range-day-month-selector-footer-confirm" onClick={handleConfirm}>
          {formatMessage({ id: 'dbi_confirm' })}
        </span>
        <span className="range-day-month-selector-footer-cancel" onClick={handleCancel}>
          {formatMessage({ id: 'dbi_cancel' })}
        </span>
      </div>
    </div>
  );
}
